import { ListProps } from "@chakra-ui/react"

import { useStbtcMintInfo } from "#/shared/hooks"

import DepositCarouselModalInfoPoints from "../../DepositCarousel/DepositCarouselModalInfoPoints"

export default function StbtcManageInfo({ ...props }: ListProps) {
  const info = useStbtcMintInfo()

  return <DepositCarouselModalInfoPoints infoPoints={info} {...props} />
}
